import React, { useState } from "react";
import {
    Chart,
    CategoryScale,
    LinearScale,
    BarElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    BarController,
} from "chart.js";
import { Bar, Line } from "react-chartjs-2";
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { useTranslation } from "react-i18next";
import { isIterableArray, pluginBg, toFormatPrice, toStringPrice } from "../../../utils/utils";


Chart.register(CategoryScale);
Chart.register(
    ChartDataLabels,
    CategoryScale,
    BarController,
    LinearScale,
    BarElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);


const GraphConsumption = (props) => {

    const { t } = useTranslation()

    const { datachar, handleClickGraph, titleTooltipFormatter, isMobile, plugins = [], graphId, fixedCount = 3, isSummTooltip = false } = props

    const options = {
        onClick: function (_, element) {
            const index = element?.[0]?.index
            if (typeof index === 'number' && handleClickGraph) handleClickGraph(index, element)
        },
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: false,
            },
            interaction: {
                intersect: false,
                mode: 'index',
            },
            tooltip: {
                position: 'nearest',
                mode: 'index',

                intersect: false,
                mode: 'index',
                xAlign: 'center',
                yAlign: 'bottom',

                backgroundColor: '#fff',
                bodyColor: '#444248',
                titleColor: '#444248',
                footerColor: '#444248',
                titleSpacing: 8,
                caretSize: 0,
                cornerRadius: 12,
                borderColor: '#EDEDED',
                borderWidth: 2,
                // displayColors: false,
                padding: 16,
                textDirection: 'top',
                titleFont: {
                    size: 18
                },
                bodyFont: {
                    size: 18
                },
                footerFont: {
                    size: 18
                },

                callbacks: {
                    title: function (tooltipItems, context) {
                        const label = titleTooltipFormatter ? titleTooltipFormatter(tooltipItems[0].label) : tooltipItems[0].label
                        const isDataInCol = isIterableArray(tooltipItems) ? tooltipItems.reduce((acc, item) => {
                            acc += item.parsed.y ? item.parsed.y : 0
                            return acc
                        }, 0) : false
                        if (!isDataInCol) return t('analytics.no_data_for') + label
                        return label
                    },
                    label: function (context) {
                        let label = context.parsed.y ? context.dataset.label : '';
                        if (context.parsed.y) {
                            if (label) {
                                label += ': ';
                            }
                            if (isIterableArray(context.dataset.data_origin)) {
                                label += fixedCount ? toFormatPrice(context.dataset.data_origin[context.dataIndex], fixedCount) : toStringPrice(context.dataset.data_origin[context.dataIndex]);
                            }
                            else {
                                label += fixedCount ? toFormatPrice(context.parsed.y, fixedCount) : toStringPrice(context.parsed.y);
                            }
                        }
                        return label;
                    },
                    footer: isSummTooltip ? function (tooltipItems, context) {
                        const isDataInCol = isIterableArray(tooltipItems) ? tooltipItems.reduce((acc, item) => {
                            acc += item.parsed.y
                            return acc
                        }, 0) : false
                        return isDataInCol ? `    ${t('analytics.total')} ${fixedCount ? toFormatPrice(isDataInCol, fixedCount) : toStringPrice(isDataInCol)}` : ''
                    } : () => (''),
                    labelColor: function (context) {
                        return {
                            backgroundColor: context.dataset.backgroundColor,
                            border: 0,
                            boxWidth: 10,
                            boxHeight: 10,
                            pointStyle: 'circle',
                            useBorderRadius: true,
                            borderRadius: 8,
                        }
                    }
                }
            },
            datalabels: {
                display: !isMobile,
                align: 'center',
                // rotation: '-90',
                anchor: 'top',
                formatter: function (value) {
                    return `${fixedCount ? toFormatPrice(value, fixedCount) : toStringPrice(value)}`;
                },
                // color: 'red',
                font: {
                    weight: 500,
                    size: 10,
                    family: 'Inter'
                }
            }
        },
        responsive: true,
        scales: {
            x: {
                display: true,
                beginAtZero: true,
                offset: true,
                stacked: true,
                border: {
                    display: false,
                },
                grid: {
                    drawBorder: false,
                    display: false,
                },
                ticks: {
                    beginAtZero: true,
                    maxRotation: 0
                }
            },
            y: {
                display: false,
                offset: true,
                stacked: true,
            },
        },
    };

    return (
        <Bar
            id={graphId}
            options={options}
            data={datachar}
            plugins={[...plugins, pluginBg]}
        />
    )
}

export default GraphConsumption